<template>
  <div class="color-panel">
    <div class="color-selected">
      <span>顏色：</span>
      <div class="color-box" :style="`background-color: ${currentColor};`"></div>
    </div>
    <div class="color-block">
      <div class="color-box" v-for="color in colors" :key="color.value" :style="`background-color: ${color.value};`" @click="changeProductColor(color.variant_id)"></div>
    </div>
    <div class="size-block">
      <div style="width: 100%; display: flex; padding: 10px;">
        <span>SIZE：</span>
      </div>
      <div class="d-flex" style="padding: 10px; gap: 1rem;">
        <div class="d-flex" v-for="(size, index) in sizes" :key="size" style="gap: 1rem;">
          <span>{{ size }}</span><span v-if="sizes.length != index+1">|</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { defineProps, defineEmits, computed } from 'vue'
  import { featureData, setFeatureData } from "~/vues/utils/feature.js"

  const props = defineProps({
    colors: {
      type: Array,
      required: true
    }
  })

  const {colors} = props
  const currentColor = computed(() => {
    return colors.find(x => x.variant_id == featureData.variantId)?.value
  })
  console.log(currentColor.value)
  const sizes = computed(() => {
    return colors.find(x => x.variant_id == featureData.variantId)?.sizes
  })

  const changeProductColor = (variantId) => {
    setFeatureData('variantId', variantId)
  }
</script>